import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import type { RemoveProjectMemberPayload } from '@/generated/types';

const REMOVE_PROJECT_MEMBER_MUTATION = gql`
  mutation RemoveProjectMember($projectId: ID!, $userId: ID!) {
    removeProjectMember(projectId: $projectId, userId: $userId) {
      success
    }
  }
`;

interface UseRemoveProjectMemberOptions {
  onCompleted?: () => void;
}

export function useRemoveProjectMember(options?: UseRemoveProjectMemberOptions) {
  const [removeMemberMutation, { loading, error }] = useMutation(REMOVE_PROJECT_MEMBER_MUTATION, {
    onCompleted: options?.onCompleted,
  });

  const removeProjectMember = async (projectId: string, userId: string) => {
    const { data } = await removeMemberMutation({
      variables: { projectId, userId },
      refetchQueries: ['Project'],
    });
    return (data as { removeProjectMember?: RemoveProjectMemberPayload } | undefined)?.removeProjectMember?.success;
  };

  return { removeProjectMember, loading, error };
}